import RPTQuickLinksTable from 'components/CIMSTable/common/components/RPTQuickLinksTable'
import {
  useCreateFdcQuickLinkMutation,
  useEditFdcQuickLinkMutation,
  useGetFdcQuickLinksQuery,
  useRestoreFdcQuickLinkMutation,
  useSoftRemoveFdcQuickLinkMutation,
} from 'schema'
import { Permission } from 'shared'

const FDCQuickLinks: React.FC = () => (
  <RPTQuickLinksTable
    entity="Field Design Change"
    query={useGetFdcQuickLinksQuery}
    getQuickLinks={(data) => data?.fdcQuickLinks?.records ?? []}
    create={{
      permission: Permission.CreateFDCQuickLink,
      mutation: useCreateFdcQuickLinkMutation,
      getLabel: ({ createFDCQuickLink: create }) => create.fdcQuickLink,
    }}
    edit={{
      permission: Permission.EditFDCQuickLink,
      mutation: useEditFdcQuickLinkMutation,
      getLabel: ({ editFDCQuickLink: edit }) => edit.fdcQuickLink,
    }}
    remove={{
      permission: Permission.RemoveRestoreFDCQuickLink,
      mutation: useSoftRemoveFdcQuickLinkMutation,
      getLabel: ({ softRemoveFDCQuickLink: remove }) => remove.fdcQuickLink,
    }}
    restore={{
      permission: Permission.RemoveRestoreFDCQuickLink,
      mutation: useRestoreFdcQuickLinkMutation,
      getLabel: ({ restoreFDCQuickLink: restore }) => restore.fdcQuickLink,
    }}
  />
)

export default FDCQuickLinks
